var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7704 0.5H4.66649C4.2631 0.5 3.93571 0.834328 3.93571 1.24627V4.52637H0.723697C0.320308 4.52637 -0.00708008 4.8607 -0.00708008 5.27264V19.7537C-0.00708008 20.1657 0.320308 20.5 0.723697 20.5H11.8276C12.231 20.5 12.5584 20.1657 12.5584 19.7537V16.4736H15.7704C16.1738 16.4736 16.5012 16.1393 16.5012 15.7274V1.24627C16.5012 0.834328 16.1738 0.5 15.7704 0.5ZM11.0968 19.0075H1.45447V6.01891H11.0968V19.0075ZM15.0396 14.9811H12.5584V5.27264C12.5584 4.8607 12.231 4.52637 11.8276 4.52637H5.39726V1.99254H15.0396V14.9811Z",
    fill: "#3C3F41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e39212e021bc79802dcde70565f222c2.svg";
export { ForwardRef as ReactComponent };